































































import { useRoute, defineComponent } from '@nuxtjs/composition-api';
import { SHOP_EMAIL, SHOP_TITLE, SHOP_PHONE } from '~/config/base';
import { loadCartMixin } from '~/mixins/loadCartMixin';

export default defineComponent({
  name: 'TypLayout',
  components: {
    HeaderSteps: () => import(/* webpackPrefetch: true */ '~/modules/checkout/components/HeaderSteps.vue'),
  },
  setup() {
    loadCartMixin();
    const route = useRoute();

    return {
      route,
      SHOP_TITLE,
      SHOP_EMAIL,
      SHOP_PHONE,
    };
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
});
